export default "__VITE_ASSET__Dndf74uH__"